export default class EventListener {
  public type: string;

  public handler: Function;

  public priolity: number;

  constructor(type: string = null, handler: Function = null, priolity: number = 0) {
    this.type = type;
    this.handler = handler;
    this.priolity = priolity;
  }

  equalCurrentListener(type: string, handler: Function): boolean {
    if (this.type === type && this.handler === handler) {
      return true;
    }
    return false;
  }
}
